import { noop } from "lodash";
import type { RegisterOptions } from "react-hook-form";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import type { ButtonWithDisabledProps } from "@circle-react-uikit/ButtonWithDisabled";
import { ButtonWithDisabled } from "@circle-react-uikit/ButtonWithDisabled";

export interface AddRemoveToggleProps
  extends Omit<ButtonWithDisabledProps, "onChange"> {
  addText?: string;
  className?: string;
  name: string;
  onChange?: (value: any) => void;
  removeText?: string;
  rules?: RegisterOptions;
}

export const AddRemoveToggle = ({
  name,
  rules = {},
  onChange = noop,
  className = "",
  addText = t("add"),
  removeText = t("remove"),
  ...props
}: AddRemoveToggleProps) => {
  const { register, watch, setValue, getValues } = useFormContext();
  const fieldValue = watch(name);

  const onClick = () => {
    const isNewValue = !getValues(name);
    setValue(name, isNewValue);
    onChange(isNewValue);
  };

  return (
    <>
      <input type="hidden" {...register(name, rules)} />
      <ButtonWithDisabled
        variant={fieldValue ? "secondary" : "primary"}
        className={className}
        onClick={onClick}
        {...props}
      >
        {fieldValue && removeText}
        {!fieldValue && addText}
      </ButtonWithDisabled>
    </>
  );
};
